// extracted by mini-css-extract-plugin
module.exports = {"controls":"BottomPaginationControls_controls___EKKf","btns":"BottomPaginationControls_btns__62Ajc"};